function parseIds(value) {
  if (!value) return [];
  return value
    .split(",")
    .map((x) => parseInt(x.trim(), 10))
    .filter((x) => !Number.isNaN(x));
}

function joinIds(ids) {
  return (ids || []).filter((x) => x != null && x !== "").join(",");
}

export function emptySurveyExclusions() {
  return {
    excludedItsIds: "",
    excludedOrganizationIds: [],
    exclusionReason: "",
  };
}

export function exclusionsFromApi(data) {
  if (data.excludedItsIds != null || data.excludedOrganizationIds != null || data.exclusionReason != null) {
    return {
      excludedItsIds: data.excludedItsIds || "",
      excludedOrganizationIds: parseIds(data.excludedOrganizationIds),
      exclusionReason: data.exclusionReason || "",
    };
  }

  const legacy = data.exclusions || [];
  const active = legacy.filter((x) => x.isActive !== false);
  return {
    excludedItsIds: active
      .filter((x) => x.itsId)
      .map((x) => x.itsId)
      .join(","),
    excludedOrganizationIds: active
      .filter((x) => x.organizationId)
      .map((x) => x.organizationId),
    exclusionReason: active.find((x) => x.reason)?.reason || "",
  };
}

export function hasExclusions(exclusions) {
  if (!exclusions) return false;
  return !!(
    exclusions.excludedItsIds?.trim() ||
    exclusions.excludedOrganizationIds?.length
  );
}

export function exclusionsToPayload(exclusions) {
  return {
    excludedItsIds: exclusions.excludedItsIds?.trim() || null,
    excludedOrganizationIds: exclusions.excludedOrganizationIds?.length
      ? joinIds(exclusions.excludedOrganizationIds)
      : null,
    exclusionReason: exclusions.exclusionReason?.trim() || null,
  };
}
